import React, { Component } from 'react';
import __ from 'lodash';
import {Row, Col, Form,Table} from 'react-bootstrap';
import SoalAkmReq from '../../../../entity/SoalAkmReq';
import { CONFIG,URL_AKM } from '../../../../config';
import { metadataApi as akmApi } from '../../../../apis/indicatorApi';
import { readableText } from './indicatorWorkflow';
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class SoalDragDrop extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            soal: this.props.soal,
            soalDetailAkm: [],
            teori:[],
            pernyataanTeori: '',
            jawabanTeori: '',
            tempId: 1
        }
    }

    async componentDidMount() {  
        
        console.log('props ==> ', this.props.soal.idBankSoal);
        
        if(this.props.soal.idBankSoal){
            this.fetchSoalDetailAkm();
        }
        (function()
        {
          if( window.localStorage )
          {
            if( !localStorage.getItem('firstLoad') )
            {
              localStorage['firstLoad'] = true;
              window.location.reload();
            }  
            else
              localStorage.removeItem('firstLoad');
          }
        })();
    }

    async fetchSoalDetailAkm() {
        this.setState({ soalDetailAkm: []})
        const response = await akmApi.get(URL_AKM.GET_SOAL_DETAIL_AKM_BY_IDBANKSOAL + this.props.soal.idBankSoal)
        .catch(function(error){ alert(error) })
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                if(response.data.data !== null) {
                    let pernyataanTeori = response.data.data.find(data => data.kunciJawaban !== null);
                    let jawabanTeori = response.data.data.find(data => data.kunciJawaban === null);
                    this.setState({
                        soalDetailAkm: response.data.data,
                        pernyataanTeori: pernyataanTeori ? pernyataanTeori.teori : '',
                        jawabanTeori: jawabanTeori ? jawabanTeori.teori : '',
                        tempId: Math.max(0, ...response.data.data.map(row => Number(row.id) || 0)) + 1
                    })
                    this.props.addSoalDetailAkm(response.data.data);
                }
                
                
            } 
        }
    }  

    addPernyataan() {
        const value = document.getElementById('pernyataan-teori').value;
        if(value === '') {
            alert('Title Pernyataan Harus diisi ya...');
            document.getElementById('pernyataan-teori').focus();
            return false;
        }
        const {tempId} = this.state;

        this.setState(prevState => ({ soalDetailAkm: [...prevState.soalDetailAkm, 
            {...SoalAkmReq, id: tempId, teori: value, kunciJawaban: 0 } 
        ]}), () => this.props.addSoalDetailAkm(this.state.soalDetailAkm))

        this.setState({ tempId: tempId + 1})
    }

    deletePernyataan(id) {
        const array = this.state.soalDetailAkm.filter(row => row.id !== id).map(row => String(row.kunciJawaban) === String(id) ? {...row, kunciJawaban: '0'} : row);
        this.setState({
            soalDetailAkm: array
        }) 
        this.props.addSoalDetailAkm(array);    
    }

    addjawaban() {
        const value = document.getElementById('jawaban-teori').value;
        if(value === '') {
            alert('Title Jawaban Harus diisi ya...');
            document.getElementById('jawaban-teori').focus();
            return false;
        }
        const {tempId} = this.state;

        this.setState(prevState => ({ soalDetailAkm: [...prevState.soalDetailAkm, 
            {...SoalAkmReq, id: tempId, teori: value } 
        ]}), () => this.props.addSoalDetailAkm(this.state.soalDetailAkm))

        this.setState({ tempId: tempId + 1})
    }

    handleKunciJawaban(id,event) {
        let array = [...this.state.soalDetailAkm];
        const value = event.target.value;
        array = array.map(ele => ele.id === id ? { ...ele, kunciJawaban: value } : ele)
        this.setState({ soalDetailAkm: array})
        this.props.addSoalDetailAkm(array);
    }  

    handleChangePernyataan(id,event) {
        let array = [...this.state.soalDetailAkm];
        
        const value = event.target.value;
        array = array.map(ele => ele.id === id ? { ...ele, pernyataan: value } : ele)
        this.setState({ soalDetailAkm: array})
        this.props.addSoalDetailAkm(array);
    }   
 
    render() {
            const mystyle = {
                borderTop: '1px solid #ced4da',
                padding: '10px 0',
                marginTop: '30px'
            };
            // console.log('state ==> ', this.state); 
        return (  
            <div className="container-fluid">                                               
                <Form.Group controlId="pertanyaan">
                    <Form.Label><h6>Pertanyaan: </h6></Form.Label>                        
                    <textarea className="tinymce_textarea" id="pertanyaan" value={this.state.soal.pertanyaan} required></textarea>    
                </Form.Group>
                
                <div style={mystyle}>
                    <Row>                    
                        <Col xs={12} md={6}>
                            <h6>Pernyataan:</h6> 
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">Title :</Form.Label>
                                <Col sm="10">
                                    <Form.Control type="text"
                                        name="teori-0" id="pernyataan-teori"
                                        placeholder="Input Title Pertanyaan..." 
                                        defaultValue={this.state.pernyataanTeori} required />
                                </Col>
                            </Form.Group>

                            <button type="button" className="btn btn-outline-primary" style={{width: '100%'}} onClick={() => this.addPernyataan()}><i className="fa fa-plus"></i>&nbsp;Tambah Pernyataan</button>

                            <Form.Group style={{marginTop: '5px'}}>
                                <Table bordered hover>
                                    <thead>
                                        <tr>
                                            <th width="5%">no</th>
                                            <th width="60%">Pernyataan</th>
                                            <th width="20%">Kunci Jawaban</th>
                                            <th>#</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.soalDetailAkm.filter(item => item.kunciJawaban !== null).map((e,i) => 
                                        <tr key={i}>
                                            <td>{i+1}</td>
                                            <td><input className="form-control" name={'pernyataan-'+ e.id} 
                                                type="text" placeholder="input pertanyaan..."
                                                defaultValue={e.pernyataan}
                                                onChange={this.handleChangePernyataan.bind(this,e.id)} />
                                            </td>
                                            <td>
                                                <select className="form-control" aria-label={'Pasangan pernyataan ' + (i+1)} value={e.kunciJawaban || '0'} onChange={this.handleKunciJawaban.bind(this,e.id)}>
                                                    <option disabled value="0">Pilih jawaban...</option>
                                                    {this.state.soalDetailAkm.filter(item => item.kunciJawaban === null).map((j,k) => 
                                                        <option value={j.id} key={k}>{readableText(j.pernyataan) || ('Jawaban ' + (k+1))}</option>
                                                    )}
                                                </select>
                                            </td>
                                            <td>
                                                <button type="button" className="btn btn-xs btn-danger" style={{width: '100%'}} 
                                                    onClick={() => this.deletePernyataan(e.id)}><i className="fa fa-remove"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        )}
                                    </tbody>
                                </Table>
                                
                            </Form.Group> 
                        </Col>

                        <Col xs={12} md={6}>
                            <h6>Jawaban:</h6>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">Title :</Form.Label>
                                <Col sm="10">
                                    <Form.Control type="text"
                                        name="teori-1" id="jawaban-teori"
                                        placeholder="Input Title Jawaban..."
                                        defaultValue={this.state.jawabanTeori} required />
                                </Col>
                            </Form.Group>

                            <button type="button" className="btn btn-outline-success" style={{width: '100%'}} onClick={() => this.addjawaban()}><i className="fa fa-plus"></i>&nbsp;Tambah Jawaban</button>
                            
                            <Form.Group style={{marginTop: '5px'}}>
                                <Table bordered hover>
                                    <thead>
                                        <tr>
                                            <th width="5%">no</th>
                                            <th width="85%">Jawaban</th>
                                            <th>#</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.soalDetailAkm.filter(item => item.kunciJawaban === null).map((e,i) => 
                                        <tr key={i}>
                                            <td>{i+1}</td>
                                            <td><input className="form-control" name={'jawaban-'+ e.id} 
                                                type="text" placeholder="input jawaban..."
                                                defaultValue={e.pernyataan}
                                                onChange={this.handleChangePernyataan.bind(this,e.id)} />
                                            </td>
                                            
                                            <td>
                                                <button type="button" className="btn btn-xs btn-danger" style={{width: '100%'}} 
                                                    onClick={() => this.deletePernyataan(e.id)}><i className="fa fa-remove"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        )}
                                    </tbody>
                                </Table>
                                
                            </Form.Group>
                        
                        </Col>
                    </Row>
                
                </div>

                <div style={mystyle}>
                    <Form.Group controlId="pembahasan">
                        <Form.Label><h6>Pembahasan: </h6></Form.Label>                        
                        <textarea className="tinymce_textarea" id="pembahasan" value={this.state.soal.isianJawaban||''} required></textarea>    
                    </Form.Group>
                </div>                
            </div>
        );
    }
}
 
export default SoalDragDrop;
